import React from 'react'
import './LockScreen.scss'
import { ReactComponent as RendiIcon } from "../assets/svg/mainLogo/rendiLogoBig.svg";
import { useKeycloak } from "@react-keycloak/web";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { loggingOut } from '../redux/actions/index';

function LockScreen() {
    const loggingOutFlag = useSelector(state => state.loginPage.loggingOutFlag)
    const dispatch = useDispatch()
    const { keycloak } = useKeycloak();
    // console.log(keycloak.authenticated)
    if (loggingOutFlag) {
        dispatch(loggingOut());
        keycloak.logout()
        // keycloak.login()
    }
    if (keycloak.authenticated) {
        return (<Navigate to="/repertoire" replace={true} />);
    } else {
        return (
            <div className='LockScreen'>
                <div className='logo-center'>
                    <div className='one animate_one fadeIn_one'></div>
                    <div className='two animate_two fadeIn_two'></div>
                    <div className='three animate_three fadeIn_three'></div>
                    <div className='main animate_main fadeIn_main'>
                        <RendiIcon />
                    </div>
                </div>
                <div className='login-btn animate_btn fadeIn_btn' onClick={() => keycloak.login()}>
                    <p>LOGIN</p>
                </div>
                <div className='bottom'>
                    <p className='demo animate_demo fadeIn_demo'>DEMO</p>
                    <p className='sentence'>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure dolor in hendrerit in</p>
                </div>
            </div>
        )
    }
}

export default LockScreen